/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Toast_Copilot_RemovedInputs */



/**
* | output |
* | --- |
* | "Compliance Copilot will be removed at period end." |
*
* @param {Sub_Addons_Toast_Copilot_RemovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_toast_copilot_removed = /** @type {((inputs?: Sub_Addons_Toast_Copilot_RemovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Toast_Copilot_RemovedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance Copilot wird zum Periodenende entfernt.")
	return /** @type {LocalizedString} */ ("Compliance Copilot will be removed at period end.")
});